import React, { Component, useState, useRef, useEffect, useContext, PureComponent } from 'react';
import classNames from 'classnames';
import { boundMethod } from 'autobind-decorator';
import { usePdf } from '@mikecousins/react-pdf';
import { withTranslation, useTranslation } from 'react-i18next';
import _ from 'lodash';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import uuid from 'uuid';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ReactModal from 'react-modal';
import ReactDOM from 'react-dom';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __awaiter(thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}

function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
}

var LoginForm =
/** @class */
function (_super) {
  __extends(LoginForm, _super);

  function LoginForm() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      login: '',
      password: '',
      isLoginError: false,
      isPasswordError: false
    };
    return _this;
  }

  LoginForm.prototype.render = function () {
    var errorLoginRequired = this.state.isLoginError ? this.renderValidationError(this.props.loginRequiredErrorMessage) : null;
    var errorPasswordRequired = this.state.isPasswordError ? this.renderValidationError(this.props.passwordRequiredErrorMessage) : null;
    return React.createElement("div", {
      className: 'ibox-content p-xl'
    }, React.createElement("h2", {
      className: 'font-bold text-dark'
    }, this.props.title), React.createElement("p", null, this.props.description), React.createElement("form", {
      className: 'js-form-login',
      onSubmit: this.onSubmit
    }, React.createElement("div", {
      className: classNames('form-group', this.state.isLoginError && 'has-error')
    }, React.createElement("label", null, this.props.labelLogin), React.createElement("input", {
      className: 'form-control',
      type: 'email',
      onChange: this.onLoginChange,
      value: this.state.login,
      tabIndex: 1,
      required: true,
      autoFocus: true
    }), errorLoginRequired), React.createElement("div", {
      className: classNames('form-group', this.state.isPasswordError && 'has-error')
    }, React.createElement("div", {
      className: 'row justify-content-between'
    }, React.createElement("div", {
      className: 'col-auto'
    }, React.createElement("label", null, this.props.labelPassword)), React.createElement("div", {
      className: 'col-auto'
    }, this.props.forgotPassword)), React.createElement("input", {
      className: 'form-control',
      type: 'password',
      onChange: this.onPasswordChange,
      value: this.state.password,
      required: true,
      tabIndex: 2
    }), errorPasswordRequired), React.createElement("button", {
      className: 'btn btn-primary block full-width m-b js-submit',
      tabIndex: 3
    }, this.props.labelSubmit), React.createElement("div", {
      className: 'form-text text-center text-danger js-response'
    }, this.props.invalidCredentialsErrorMessage)));
  };

  LoginForm.prototype.onLoginChange = function (event) {
    var newValue = event.target.value;
    var isEmpty = newValue.length === 0;
    this.setState({
      login: newValue,
      isLoginError: isEmpty
    });
  };

  LoginForm.prototype.onPasswordChange = function (event) {
    var newValue = event.target.value;
    var isEmpty = newValue.length === 0;
    this.setState({
      password: event.target.value,
      isPasswordError: isEmpty
    });
  };

  LoginForm.prototype.onSubmit = function (event) {
    var submitHandler = this.props.submitHandler;
    var _a = this.state,
        login = _a.login,
        password = _a.password;
    event.preventDefault();
    submitHandler(login, password);
  };

  LoginForm.prototype.renderValidationError = function (message) {
    return React.createElement("span", {
      className: classNames('form-text m-b-none text-danger', this.props.validationErrorClassName)
    }, message);
  };

  __decorate([boundMethod], LoginForm.prototype, "onLoginChange", null);

  __decorate([boundMethod], LoginForm.prototype, "onPasswordChange", null);

  __decorate([boundMethod], LoginForm.prototype, "onSubmit", null);

  return LoginForm;
}(Component);

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".sk-spinner.sk-spinner-circle.Spinner-module_circleInline__sqvtV{display:inline-block}.sk-spinner.sk-spinner-circle.Spinner-module_circleSmall__2lMbH{width:12px;height:12px}.sk-spinner.sk-spinner-circle.Spinner-module_circleWhite__3W3cE .sk-circle:before{background-color:#fff}";
var styles = {
  "circleInline": "Spinner-module_circleInline__sqvtV",
  "circleSmall": "Spinner-module_circleSmall__2lMbH",
  "circleWhite": "Spinner-module_circleWhite__3W3cE"
};
styleInject(css);

var SpinnerThreeBounce = function SpinnerThreeBounce() {
  return React.createElement("div", {
    className: 'sk-spinner sk-spinner-three-bounce'
  }, React.createElement("div", {
    className: 'sk-bounce1'
  }), React.createElement("div", {
    className: 'sk-bounce2'
  }), React.createElement("div", {
    className: 'sk-bounce3'
  }));
};

var SpinnerCircle = function SpinnerCircle(props) {
  var inline = props.inline,
      spinnerSize = props.spinnerSize,
      spinnerColor = props.spinnerColor,
      restProps = __rest(props, ["inline", "spinnerSize", "spinnerColor"]);

  return React.createElement("div", _assign({}, restProps, {
    className: classNames('sk-spinner sk-spinner-circle', props.className, props.inline && styles.circleInline, props.spinnerSize === 'small' && styles.circleSmall, props.spinnerColor === 'white' && styles.circleWhite)
  }), React.createElement("div", {
    className: 'sk-circle1 sk-circle'
  }), React.createElement("div", {
    className: 'sk-circle2 sk-circle'
  }), React.createElement("div", {
    className: 'sk-circle3 sk-circle'
  }), React.createElement("div", {
    className: 'sk-circle4 sk-circle'
  }), React.createElement("div", {
    className: 'sk-circle5 sk-circle'
  }), React.createElement("div", {
    className: 'sk-circle6 sk-circle'
  }), React.createElement("div", {
    className: 'sk-circle7 sk-circle'
  }), React.createElement("div", {
    className: 'sk-circle8 sk-circle'
  }), React.createElement("div", {
    className: 'sk-circle9 sk-circle'
  }), React.createElement("div", {
    className: 'sk-circle10 sk-circle'
  }), React.createElement("div", {
    className: 'sk-circle11 sk-circle'
  }), React.createElement("div", {
    className: 'sk-circle12 sk-circle'
  }));
};

var css$1 = ".Preloader-module_container__3H2ZO.Preloader-module_fill__1INQE{-webkit-box-flex:1;flex:1;width:100%;height:100%}.Preloader-module_container__3H2ZO.Preloader-module_overlay__1vevt{position:absolute;top:0;left:0;background:hsla(240,4%,95%,.7);z-index:1}.Preloader-module_wrapper__PnmGL{padding:30px;width:100%;height:100%;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}";
var styles$1 = {
  "container": "Preloader-module_container__3H2ZO",
  "fill": "Preloader-module_fill__1INQE",
  "overlay": "Preloader-module_overlay__1vevt",
  "wrapper": "Preloader-module_wrapper__PnmGL"
};
styleInject(css$1);

var Preloader = function Preloader(props) {
  return React.createElement("div", {
    className: classNames('animated fadeIn', styles$1.container, !props.noFill && styles$1.fill, props.overlay && styles$1.overlay)
  }, React.createElement("div", {
    className: styles$1.wrapper
  }, React.createElement(SpinnerThreeBounce, null)));
};

var Hr = function Hr(props) {
  return React.createElement("div", {
    className: "hr-line-" + props.type
  });
};

var LabelType;

(function (LabelType) {
  LabelType["INFO"] = "info";
  LabelType["PRIMARY"] = "primary";
  LabelType["WARNING"] = "warning";
  LabelType["DANGER"] = "danger";
})(LabelType || (LabelType = {}));

var Label =
/** @class */
function (_super) {
  __extends(Label, _super);

  function Label() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Label.prototype.render = function () {
    var _a = this.props,
        type = _a.type,
        children = _a.children,
        className = _a.className;
    return React.createElement("span", {
      className: classNames('label', "label-" + type, className)
    }, children);
  };

  return Label;
}(Component);

var css$2 = ".PdfViewer-module_container__38gaS{overflow:hidden;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.PdfViewer-module_pdfCanvas__3knFB{margin:0 auto}.PdfViewer-module_pdfCanvasContainer__2QKQc{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;overflow:auto;margin:16px 0}.input-group>.form-control.PdfViewer-module_pageInput__1bgJV{width:60px}";
var styles$2 = {
  "container": "PdfViewer-module_container__38gaS",
  "pdfCanvas": "PdfViewer-module_pdfCanvas__3knFB",
  "pdfCanvasContainer": "PdfViewer-module_pdfCanvasContainer__2QKQc",
  "pageInput": "PdfViewer-module_pageInput__1bgJV"
};
styleInject(css$2);
var defaultLabels = {
  labelPrevPage: 'Previous',
  labelNextPage: 'Next',
  labelZoomIn: 'Zoom in',
  labelZoomOut: 'Zoom out',
  labelPage: 'Page'
};

function PdfViewer(props) {
  var _a = useState(1),
      page = _a[0],
      setPage = _a[1];

  var _b = useState(1),
      scale = _b[0],
      setScale = _b[1];

  var _c = useState(null),
      pages = _c[0],
      setPages = _c[1];

  var canvasEl = useRef(null);

  var _d = usePdf({
    file: props.pdfUrl,
    page: page,
    canvasEl: canvasEl,
    scale: scale
  }),
      loading = _d[0],
      numPages = _d[1];

  var onPageChange = function onPageChange(e) {
    var newPage = +e.currentTarget.value;

    if (newPage > 0 && newPage <= numPages) {
      setPage(newPage);
    } else {
      e.preventDefault();
    }
  };

  var onPageInputFocus = function onPageInputFocus(e) {
    return e.currentTarget.select();
  };

  var onPrevPage = function onPrevPage() {
    var newPage = page - 1;

    if (newPage > 0 && newPage <= numPages) {
      setPage(newPage);
    }
  };

  var onNextPage = function onNextPage() {
    var newPage = page + 1;

    if (newPage > 0 && newPage <= numPages) {
      setPage(newPage);
    }
  };

  var onZoomIn = function onZoomIn() {
    return setScale(scale + 0.25);
  };

  var onZoomOut = function onZoomOut(e) {
    var newScale = scale - 0.25;

    if (newScale > 0) {
      setScale(newScale);
    } else {
      e.preventDefault();
    }
  };

  useEffect(function () {
    setPages(numPages);
  }, [numPages]);

  var renderPagination = function renderPagination(page, pages) {
    if (!pages) {
      return null;
    }

    return React.createElement("div", {
      className: 'text-center'
    }, React.createElement("div", {
      className: 'btn-group'
    }, React.createElement("button", {
      className: 'btn btn-white',
      onClick: onPrevPage
    }, React.createElement("i", {
      className: 'fa fa-long-arrow-left mr-1'
    }), React.createElement("span", {
      className: 'd-none d-sm-inline'
    }, props.labelPrevPage || defaultLabels.labelPrevPage)), React.createElement("button", {
      className: 'btn btn-white',
      onClick: onNextPage
    }, React.createElement("i", {
      className: 'fa fa-long-arrow-right mr-1'
    }), React.createElement("span", {
      className: 'd-none d-sm-inline'
    }, props.labelNextPage || defaultLabels.labelNextPage)), React.createElement("button", {
      className: 'btn btn-white',
      onClick: onZoomIn
    }, React.createElement("i", {
      className: 'fa fa-search-plus mr-1'
    }), React.createElement("span", {
      className: 'd-none d-sm-inline'
    }, props.labelZoomIn || defaultLabels.labelZoomIn)), React.createElement("button", {
      className: 'btn btn-white',
      onClick: onZoomOut
    }, React.createElement("i", {
      className: 'fa fa-search-minus mr-1'
    }), React.createElement("span", {
      className: 'd-none d-sm-inline'
    }, props.labelZoomOut || defaultLabels.labelZoomOut)), React.createElement("button", {
      className: 'btn btn-white'
    }, Math.round(scale * 100), "%"), React.createElement("button", {
      className: 'btn btn-white hidden-xs'
    }, props.labelPage || defaultLabels.labelPage, ": "), React.createElement("div", {
      className: 'input-group'
    }, React.createElement("input", {
      type: 'text',
      className: classNames('form-control', styles$2.pageInput),
      value: page,
      onChange: onPageChange,
      onFocus: onPageInputFocus
    }), React.createElement("div", {
      className: 'input-group-append'
    }, React.createElement("button", {
      type: 'button',
      className: 'btn btn-white'
    }, "/ ", pages))), React.createElement("a", {
      href: props.pdfDownloadUrl || props.pdfUrl,
      className: 'btn btn-white ml-3',
      download: true
    }, React.createElement("i", {
      className: 'fa fa-download'
    }))));
  };

  return React.createElement("div", {
    className: styles$2.container
  }, renderPagination(page, pages || 0), loading && React.createElement(Preloader, {
    overlay: true
  }), React.createElement("div", {
    className: styles$2.pdfCanvasContainer
  }, React.createElement("canvas", {
    ref: canvasEl,
    className: styles$2.pdfCanvas
  })));
}

var ErrorContext = React.createContext({
  errors: {},
  touched: {}
}); // Copyright Joyent, Inc. and other Node contributors.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(ar) {
  return Array.isArray(ar);
}

function isString(arg) {
  return typeof arg === 'string';
}

function prepareErrors(errors, touched, field) {
  var _a;

  var fieldsConfig = isString(field) ? (_a = {}, _a[field] = {}, _a) : field;
  var resultErrors = [];

  for (var field_1 in fieldsConfig) {
    var errorParams = fieldsConfig[field_1]; // we are interested only in touched fields with errors

    if (isArray(touched) && isArray(errors)) {
      var fieldParts = field_1.split('.'); // const baseFieldName = +fieldParts[0];

      var index = +fieldParts[1];
      var fieldNameInObject = fieldParts[2];

      if (touched[index] && touched[index][fieldNameInObject] && errors[index] && errors[index][fieldNameInObject]) {
        resultErrors.push({
          message: errors[index][fieldNameInObject],
          params: errorParams
        });
      }
    } else if (touched[field_1] && errors[field_1]) {
      resultErrors.push({
        message: errors[field_1] || '',
        params: errorParams
      });
    }
  }

  return resultErrors;
}

function withErrorsContext(Component) {
  return function (_a) {
    var forProp = _a.for,
        children = _a.children,
        props = __rest(_a, ["for", "children"]);

    var _b = useContext(ErrorContext),
        errors = _b.errors,
        touched = _b.touched;

    return React.createElement(Component, _assign({
      errors: prepareErrors(errors, touched, forProp)
    }, props), children);
  };
}
/**
 * Container for a field with help text displayed on the side.
 */


var FieldWithHelp =
/** @class */
function (_super) {
  __extends(FieldWithHelp, _super);

  function FieldWithHelp() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  FieldWithHelp.prototype.render = function () {
    var _a = this.props,
        label = _a.label,
        helpText = _a.helpText,
        children = _a.children,
        errors = _a.errors;
    return React.createElement("div", {
      className: classNames('row form-group', errors.length && 'has-error', this.props.className)
    }, label && React.createElement("div", {
      className: 'col-12'
    }, React.createElement("label", null, label)), React.createElement("div", {
      className: 'col-xs-12 col-sm-7 col-md-9'
    }, children, this.props.errorComponent || this.renderErrors()), React.createElement("div", {
      className: 'col-xs-12 col-sm-5 col-md-3'
    }, helpText));
  };

  FieldWithHelp.prototype.renderErrors = function () {
    var _a = this.props,
        t = _a.t,
        i18n = _a.i18n,
        errors = _a.errors;
    return _.uniqBy(errors, function (error) {
      return error.message;
    }).map(function (error, idx) {
      var messageString = typeof error.message === 'string' ? error.message : error.message.key;

      var tParams = _assign({}, error.params);

      if (typeof error.message !== 'string') {
        tParams = _assign(_assign({}, tParams), error.message.values);
      }

      var errorMessage = messageString;

      if (i18n.exists && i18n.exists(messageString)) {
        errorMessage = t(messageString, tParams);
      }

      return React.createElement("span", {
        key: idx,
        className: 'form-text m-b-none text-danger'
      }, errorMessage);
    });
  };

  return FieldWithHelp;
}(Component);

var FieldWithHelp$1 = withErrorsContext(withTranslation()(FieldWithHelp));

var LabelFieldHorizontal =
/** @class */
function (_super) {
  __extends(LabelFieldHorizontal, _super);

  function LabelFieldHorizontal() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  LabelFieldHorizontal.prototype.render = function () {
    var _a = this.props,
        errors = _a.errors,
        children = _a.children,
        label = _a.label;
    return React.createElement("div", {
      className: classNames('form-group', this.props.className, errors.length && 'has-error')
    }, label && React.createElement("label", null, label), React.createElement("div", {
      className: 'input-group'
    }, children), this.props.errorComponent || this.renderErrors());
  };

  LabelFieldHorizontal.prototype.renderErrors = function () {
    var _a = this.props,
        t = _a.t,
        i18n = _a.i18n,
        errors = _a.errors;
    return _.uniqBy(errors, function (error) {
      return error.message;
    }).map(function (error, idx) {
      var messageString = typeof error.message === 'string' ? error.message : error.message.key;

      var tParams = _assign({}, error.params);

      if (typeof error.message !== 'string') {
        tParams = _assign(_assign({}, tParams), error.message.values);
      }

      var errorMessage = messageString;

      if (i18n.exists && i18n.exists(messageString)) {
        errorMessage = t(messageString, tParams);
      }

      return React.createElement("span", {
        key: idx,
        className: 'form-text m-b-none text-danger'
      }, errorMessage);
    });
  };

  return LabelFieldHorizontal;
}(Component);

var LabelFieldHorizontal$1 = withErrorsContext(withTranslation()(LabelFieldHorizontal));
var css$3 = ".PropertyRow-module_rowContainer__1bNxw{display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;padding:9px 0;border-bottom:1px solid #e7eaec}.PropertyRow-module_rowContainer__1bNxw label{margin-bottom:0}.PropertyRow-module_rowLabel__oeURy{-webkit-box-flex:1;flex:1;margin:0 12px 0 0}";
var styles$3 = {
  "rowContainer": "PropertyRow-module_rowContainer__1bNxw",
  "rowLabel": "PropertyRow-module_rowLabel__oeURy"
};
styleInject(css$3);

var PropertyRow = function PropertyRow(props) {
  return React.createElement("div", {
    className: styles$3.rowContainer
  }, React.createElement("label", {
    className: classNames(styles$3.rowLabel, 'font-bold')
  }, props.label), React.createElement("div", null, props.children));
};

var DatePickerInput =
/** @class */
function (_super) {
  __extends(DatePickerInput, _super);

  function DatePickerInput() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  DatePickerInput.prototype.render = function () {
    // props passed to the react-datepicker component
    var props = _assign(_assign({}, this.props), {
      autoComplete: 'off',
      onChange: this.onChange,
      className: 'form-control'
    });

    return React.createElement("label", {
      className: 'd-flex w-100 mb-0'
    }, React.createElement("div", {
      className: 'input-group-prepend'
    }, React.createElement("span", {
      className: 'input-group-addon'
    }, React.createElement("i", {
      className: 'fa fa-calendar'
    }))), React.createElement(ReactDatePicker, _assign({}, props)));
  };

  DatePickerInput.prototype.onChange = function (date) {
    this.props.onChange(this.props.name, date ? moment(date).format(this.props.valueDateFormat) : '');
  };

  __decorate([boundMethod], DatePickerInput.prototype, "onChange", null);

  return DatePickerInput;
}(Component);

var TextInput = function TextInput(props) {
  var inputRef = props.inputRef,
      inputProps = __rest(props, ["inputRef"]);

  return React.createElement("input", _assign({}, inputProps, {
    ref: props.inputRef,
    type: 'text',
    className: classNames('form-control', props.className)
  }));
};

var GeoLocation =
/** @class */
function (_super) {
  __extends(GeoLocation, _super);

  function GeoLocation() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.inputRef = React.createRef();
    /**
     * FIXME: as a workaround, we are completely disabling submitting form on ENTER
     * because hitting ENTER when selecting autocomplete option also submitted the form.
     */

    _this.onKeyDown = function (e) {
      if (e.keyCode === 13) {
        e.preventDefault();
      }
    };

    return _this;
  }

  GeoLocation.prototype.componentDidMount = function () {
    // init autocomplete input
    if (this.inputRef.current) {
      this.searchbox = new google.maps.places.Autocomplete(this.inputRef.current, {
        fields: ['geometry.location']
      });
      this.searchbox.addListener('place_changed', this.onPlaceChanged);
    }
  };

  GeoLocation.prototype.render = function () {
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: 'input-group'
    }, React.createElement(TextInput, {
      inputRef: this.inputRef,
      className: classNames('form-control', this.props.className),
      placeholder: this.props.placeholder,
      defaultValue: this.props.valueAddress,
      onKeyDown: this.onKeyDown
    })), React.createElement("input", {
      type: 'hidden',
      name: this.props.nameLat,
      defaultValue: "" + (this.props.valueLat || '')
    }), React.createElement("input", {
      type: 'hidden',
      name: this.props.nameLng,
      defaultValue: "" + (this.props.valueLng || '')
    }));
  };

  GeoLocation.prototype.onPlaceChanged = function () {
    if (this.searchbox && this.searchbox.getPlace()) {
      var place = this.searchbox.getPlace();
      var lat = place.geometry && place.geometry.location.lat();
      var lng = place.geometry && place.geometry.location.lng();
      var address = this.inputRef.current && this.inputRef.current.value || '';

      if (lat !== undefined && lng !== undefined) {
        this.props.setFieldValue(this.props.nameLat, "" + lat);
        this.props.setFieldValue(this.props.nameLng, "" + lng);
        this.props.setFieldValue(this.props.nameAddress, "" + address);
      }
    }
  };

  __decorate([boundMethod], GeoLocation.prototype, "onPlaceChanged", null);

  return GeoLocation;
}(Component);

var css$4 = ".Select-module_container__1LnGD{position:relative;-webkit-box-flex:1;flex:1;width:100%}.Select-module_container__1LnGD>select{-webkit-appearance:none;-moz-appearance:none;appearance:none;width:100%;padding-right:20px}.Select-module_container__1LnGD:after{font-family:FontAwesome;content:\"\\F0D7\";display:-webkit-box;display:flex;position:absolute;right:0;top:0;width:24px;height:100%;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;font-size:14px;pointer-events:none}";
var styles$4 = {
  "container": "Select-module_container__1LnGD"
};
styleInject(css$4);

var Select = function Select(props) {
  return React.createElement("div", {
    className: styles$4.container
  }, React.createElement("select", _assign({}, props, {
    className: classNames('form-control', props.className)
  }), props.children));
};

var css$5 = ".Checkbox-module_checkbox__1FIml{display:-webkit-box;display:flex;flex-wrap:nowrap}.Checkbox-module_checkbox__1FIml.Checkbox-module_fill__2vOJ5{-webkit-box-flex:1;flex:1}.Checkbox-module_checkbox__1FIml label{-webkit-box-flex:1;flex:1;margin-bottom:0}.Checkbox-module_checkbox__1FIml input[type=checkbox],.Checkbox-module_checkbox__1FIml input[type=radio]{flex-basis:1px;margin-right:8px;position:relative;-webkit-appearance:none;-moz-appearance:none;appearance:none}.Checkbox-module_checkbox__1FIml input[type=checkbox]:before,.Checkbox-module_checkbox__1FIml input[type=radio]:before{visibility:visible;content:\"\";display:block;width:20px;height:20px;border:1px solid #e7eaec;background:#fff}.Checkbox-module_checkbox__1FIml input[type=checkbox]:hover:before,.Checkbox-module_checkbox__1FIml input[type=radio]:hover:before{background-color:#fafafa}.Checkbox-module_checkbox__1FIml input[type=checkbox]:checked:hover:before,.Checkbox-module_checkbox__1FIml input[type=radio]:checked:hover:before{background-color:#19aa8d}.Checkbox-module_checkbox__1FIml input[type=checkbox]:checked:before,.Checkbox-module_checkbox__1FIml input[type=radio]:checked:before{background:#1ab394}.Checkbox-module_checkbox__1FIml input[type=checkbox]:checked:after,.Checkbox-module_checkbox__1FIml input[type=radio]:checked:after{font-family:FontAwesome;content:\"\\F00C\";font-size:10px;color:#fff;display:block;width:20px;height:20px;line-height:20px;top:0;left:0;position:absolute;text-align:center}.Checkbox-module_checkbox__1FIml input[type=radio]:before{border-radius:50%}";
var styles$5 = {
  "checkbox": "Checkbox-module_checkbox__1FIml",
  "fill": "Checkbox-module_fill__2vOJ5"
};
styleInject(css$5);

var Checkbox = function Checkbox(props) {
  var id = useState(uuid.v4())[0];

  var label = props.label,
      inputProps = __rest(props, ["label"]);

  return React.createElement("div", {
    className: classNames(styles$5.checkbox, props.noFill === true && styles$5.fill)
  }, React.createElement("input", _assign({}, inputProps, {
    id: id,
    type: 'checkbox'
  })), label && React.createElement("label", {
    htmlFor: id
  }, label));
};

var Radio = function Radio(props) {
  var id = useState(uuid.v4())[0];

  var label = props.label,
      inputProps = __rest(props, ["label"]);

  return React.createElement("div", {
    className: styles$5.checkbox
  }, React.createElement("input", _assign({}, inputProps, {
    id: id,
    type: 'radio'
  })), React.createElement("label", {
    htmlFor: id
  }, label));
};

var CheckboxGroup =
/** @class */
function (_super) {
  __extends(CheckboxGroup, _super);

  function CheckboxGroup() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderCheckboxChild = function (child) {
      return React.cloneElement(child, {
        checked: _this.props.value.includes(child.props.value),
        onChange: _this.onChange,
        onBlur: _this.onBlur
      });
    };

    _this.onChange = function (e) {
      var target = e.currentTarget;

      var valuesArr = __spreadArrays(_this.props.value);

      if (target.checked) {
        valuesArr.push(target.value);
      } else {
        valuesArr.splice(valuesArr.indexOf(target.value), 1);
      }

      _this.props.handleChange(_this.props.name, valuesArr);
    };

    _this.onBlur = function () {
      _this.props.handleBlur(_this.props.id, true);
    };

    return _this;
  }

  CheckboxGroup.prototype.render = function () {
    return React.createElement("div", {
      className: 'form-group mb-0'
    }, React.Children.map(this.props.children, this.renderCheckboxChild));
  };

  return CheckboxGroup;
}(Component);

var Switch = function Switch(props) {
  var id = props.id || uuid.v4();
  return React.createElement("div", {
    className: 'switch'
  }, React.createElement("div", {
    className: 'onoffswitch'
  }, React.createElement("input", _assign({}, props, {
    id: id,
    type: 'checkbox',
    className: classNames('onoffswitch-checkbox', props.className)
  })), React.createElement("label", {
    className: 'onoffswitch-label',
    htmlFor: id
  }, React.createElement("span", {
    className: 'onoffswitch-inner'
  }), React.createElement("span", {
    className: 'onoffswitch-switch'
  }))));
};

var css$6 = ".FileUpload-module_container__3XNlg{display:-webkit-box;display:flex;-webkit-box-align:baseline;align-items:baseline;margin-bottom:0;-webkit-box-flex:1;flex:1;width:100%}.FileUpload-module_container__3XNlg input[type=file]{display:none}.FileUpload-module_messages__2lm8g{-webkit-box-flex:1;flex:1;margin-left:16px;font-size:14px;overflow:hidden}.FileUpload-module_placeholder__3CvTm{color:#aaa;display:inline-block;width:100%;text-overflow:ellipsis}";
var styles$6 = {
  "container": "FileUpload-module_container__3XNlg",
  "messages": "FileUpload-module_messages__2lm8g",
  "placeholder": "FileUpload-module_placeholder__3CvTm"
};
styleInject(css$6);

var FileUpload =
/** @class */
function (_super) {
  __extends(FileUpload, _super);

  function FileUpload() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isUploading: false,
      isUploadFinished: false
    };

    _this.renderPlaceholder = function () {
      if (_this.state.errorMessage) {
        // error message after failed upload
        return React.createElement("span", {
          className: classNames(styles$6.placeholder, 'text-danger')
        }, _this.state.errorMessage);
      } else if (_this.state.selectedFileName === undefined && _this.props.placeholder) {
        // placeholder if no file is selected
        return React.createElement("span", {
          className: styles$6.placeholder
        }, _this.props.placeholder);
      } else if (_this.state.selectedFileName !== undefined) {
        // file name instead of the placeholder if a file is selected
        return React.createElement("span", {
          className: styles$6.placeholder
        }, _this.state.selectedFileName);
      }

      return null;
    };

    _this.isDisabled = function () {
      return _this.props.disabled || _this.state.isUploading;
    };

    return _this;
  }

  FileUpload.prototype.componentDidMount = function () {
    if (this.props.value) {
      this.setState({
        selectedFileName: this.props.value.fileName,
        isUploadFinished: true
      });
    }
  };

  FileUpload.prototype.render = function () {
    var id = this.props.id || uuid.v4();

    var _a = this.props,
        labelButton = _a.labelButton,
        placeholder = _a.placeholder,
        doUploadFile = _a.doUploadFile,
        setFieldValue = _a.setFieldValue,
        accept = _a.accept,
        disabled = _a.disabled,
        inputProps = __rest(_a, ["labelButton", "placeholder", "doUploadFile", "setFieldValue", "accept", "disabled"]);

    return React.createElement("label", {
      htmlFor: id,
      className: styles$6.container
    }, React.createElement("input", {
      id: id,
      type: 'file',
      onChange: this.onFileChange,
      accept: accept,
      disabled: this.isDisabled()
    }), React.createElement("div", {
      className: classNames('btn btn-default btn-w-m font-bold', this.isDisabled() && 'disabled')
    }, labelButton), React.createElement("div", {
      className: styles$6.messages
    }, this.renderPlaceholder()), this.state.isUploading && React.createElement(SpinnerCircle, {
      spinnerSize: 'small'
    }), !this.state.isUploading && this.state.isUploadFinished && this.state.selectedFileName !== undefined && React.createElement("i", {
      className: 'fa fa-check-circle text-info'
    }), React.createElement("input", _assign({
      type: 'hidden'
    }, inputProps, {
      disabled: disabled,
      value: this.props.value ? this.props.value.fileId : ''
    })));
  };

  FileUpload.prototype.onFileChange = function (e) {
    return __awaiter(this, void 0, void 0, function () {
      var file, uploadedFileId, uploadError_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!e.target.files || !e.target.files.length) {
              // don't do anything on file browser cancel
              return [2
              /*return*/
              ];
            }

            file = e.target.files.item(0);
            if (!file) return [3
            /*break*/
            , 4];
            this.setState({
              selectedFileName: file.name,
              isUploading: this.props.doUploadFile !== undefined
            });
            if (!this.props.doUploadFile) return [3
            /*break*/
            , 4];
            _a.label = 1;

          case 1:
            _a.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , this.props.doUploadFile(file)];

          case 2:
            uploadedFileId = _a.sent();
            this.props.setFieldValue(this.props.name, {
              fileId: uploadedFileId,
              fileName: file.name
            });
            this.setState({
              isUploading: false,
              isUploadFinished: true,
              errorMessage: undefined
            });
            return [3
            /*break*/
            , 4];

          case 3:
            uploadError_1 = _a.sent();
            this.setState({
              isUploading: false,
              isUploadFinished: false,
              errorMessage: uploadError_1.message || 'ERROR'
            });
            return [3
            /*break*/
            , 4];

          case 4:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  __decorate([boundMethod], FileUpload.prototype, "onFileChange", null);

  return FileUpload;
}(Component);

var css$7 = ".InputWheel-module_wheelContainer__2DlKf{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-align:stretch;align-items:stretch}.InputWheel-module_wheelBtn__1GGQP{-webkit-box-flex:1;flex:1;font-size:.5em;padding:0 7px;display:-webkit-box;display:flex;-webkit-box-align:center;align-items:center;background-color:#fff;border:1px solid #e5e6e7;border-left-color:transparent;border-radius:3px;border-top-right-radius:3px;-webkit-transition:border-color .15s ease-in-out 0s,box-shadow .15s ease-in-out 0s;transition:border-color .15s ease-in-out 0s,box-shadow .15s ease-in-out 0s;width:100%}.InputWheel-module_wheelBtn__1GGQP.InputWheel-module_down__n7msD{border-top-color:transparent;border-top-right-radius:0;border-bottom-right-radius:3px}";
var styles$7 = {
  "wheelContainer": "InputWheel-module_wheelContainer__2DlKf",
  "wheelBtn": "InputWheel-module_wheelBtn__1GGQP",
  "down": "InputWheel-module_down__n7msD"
};
styleInject(css$7);

var InputWheel =
/** @class */
function (_super) {
  __extends(InputWheel, _super);

  function InputWheel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  InputWheel.prototype.render = function () {
    return React.createElement("div", {
      className: styles$7.wheelContainer
    }, React.createElement("button", {
      className: classNames(styles$7.wheelBtn, 'btn'),
      onClick: this.onPressUp,
      tabIndex: -1
    }, React.createElement("i", {
      className: 'fa fa-chevron-up'
    })), React.createElement("button", {
      className: classNames(styles$7.wheelBtn, styles$7.down, 'btn'),
      onClick: this.onPressDown,
      tabIndex: -1
    }, React.createElement("i", {
      className: 'fa fa-chevron-down'
    })));
  };

  InputWheel.prototype.onPressUp = function (event) {
    event.preventDefault();

    if (this.props.onPressUp) {
      this.props.onPressUp();
    }
  };

  InputWheel.prototype.onPressDown = function (event) {
    event.preventDefault();

    if (this.props.onPressDown) {
      this.props.onPressDown();
    }
  };

  __decorate([boundMethod], InputWheel.prototype, "onPressUp", null);

  __decorate([boundMethod], InputWheel.prototype, "onPressDown", null);

  return InputWheel;
}(Component);

var NumberInput =
/** @class */
function (_super) {
  __extends(NumberInput, _super);

  function NumberInput() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  NumberInput.prototype.render = function () {
    var _a = this.props,
        value = _a.value,
        inputRef = _a.inputRef,
        onChange = _a.onChange,
        inputProps = __rest(_a, ["value", "inputRef", "onChange"]);

    return React.createElement("input", _assign({}, inputProps, {
      value: this.props.value === undefined ? '' : this.props.value,
      ref: inputRef,
      onChange: onChange,
      onKeyPress: this.onKeyPress,
      type: 'text',
      className: classNames('form-control flex-fill', this.props.className)
    }));
  };
  /**
   * Prevent non-numeric characters.
   */


  NumberInput.prototype.onKeyPress = function (event) {
    if (!/[0-9-]/.test(event.key)) {
      event.preventDefault();
    }
  };

  return NumberInput;
}(Component);

function stringToNumber(value, defaultValue) {
  if (!value) {
    return defaultValue;
  }

  return +value;
}

function numberToString(value) {
  return value === undefined || isNaN(value) ? '' : "" + value;
}

function formValueToString(value) {
  if (value === undefined) {
    return '';
  }

  if (typeof value === 'number' && isNaN(value)) {
    return '';
  }

  return "" + value;
}

var WheeledNumberInput =
/** @class */
function (_super) {
  __extends(WheeledNumberInput, _super);

  function WheeledNumberInput() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.inputRef = React.createRef();
    _this.state = {
      value: formValueToString(_this.props.value)
    };
    return _this;
  }

  WheeledNumberInput.prototype.componentDidUpdate = function (prevProps) {
    var newValueAsString = formValueToString(this.props.value);

    if (prevProps.value !== this.props.value && newValueAsString !== this.state.value) {
      this.setState({
        value: newValueAsString
      });
    }
  };

  WheeledNumberInput.prototype.render = function () {
    var _a = this.props,
        onChange = _a.onChange,
        ref = _a.ref,
        setFieldValue = _a.setFieldValue,
        inputProps = __rest(_a, ["onChange", "ref", "setFieldValue"]);

    return React.createElement("div", {
      className: 'd-flex w-100'
    }, React.createElement(NumberInput, _assign({
      inputRef: this.inputRef
    }, inputProps, {
      value: this.state.value,
      onChange: this.onChange
    })), React.createElement(InputWheel, {
      onPressUp: this.onPressUp,
      onPressDown: this.onPressDown
    }));
  };

  WheeledNumberInput.prototype.onChange = function (e) {
    this.setState({
      value: e.target.value
    }, this.onChangeCallback);
  };

  WheeledNumberInput.prototype.onPressUp = function () {
    // increment by 1
    this.setState(function (state) {
      return {
        value: numberToString(stringToNumber(state.value, 0) + 1)
      };
    }, this.onChangeCallback);
  };

  WheeledNumberInput.prototype.onPressDown = function () {
    // decrement by 1
    this.setState(function (state) {
      return {
        value: numberToString(stringToNumber(state.value, 0) - 1)
      };
    }, this.onChangeCallback);
  };

  WheeledNumberInput.prototype.onChangeCallback = function () {
    this.props.setFieldValue(this.props.name, this.state.value); // focus input field

    if (this.inputRef.current) {
      this.inputRef.current.focus();
    }
  };

  __decorate([boundMethod], WheeledNumberInput.prototype, "onChange", null);

  __decorate([boundMethod], WheeledNumberInput.prototype, "onPressUp", null);

  __decorate([boundMethod], WheeledNumberInput.prototype, "onPressDown", null);

  __decorate([boundMethod], WheeledNumberInput.prototype, "onChangeCallback", null);

  return WheeledNumberInput;
}(Component);

var css$8 = ".rdw-editor-wrapper{-webkit-box-flex:1;flex:1;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column}.Wysiwyg-module_editor__1nvPF{padding:0 14px;min-height:150px;background-color:#fff;border:1px solid #e7eaec}.Wysiwyg-module_toolbar__3D27q{margin-bottom:0;background-color:#f7f7f7;border:1px solid #e7eaec;border-bottom:none}.Wysiwyg-module_toolbar__3D27q .rdw-option-wrapper{height:30px;min-width:35px}.Wysiwyg-module_toolbar__3D27q .rdw-dropdown-wrapper,.Wysiwyg-module_toolbar__3D27q .rdw-option-wrapper{background:transparent;border:none}";
var styles$8 = {
  "editor": "Wysiwyg-module_editor__1nvPF",
  "toolbar": "Wysiwyg-module_toolbar__3D27q"
};
styleInject(css$8);
var toolbarConfig = {
  options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign'],
  inline: {
    inDropdown: false,
    options: ['bold', 'italic', 'underline', 'strikethrough']
  },
  blockType: {
    inDropdown: true,
    options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']
  },
  fontSize: {
    options: [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96]
  },
  list: {
    inDropdown: false
  },
  textAlign: {
    inDropdown: false,
    options: ['left', 'center', 'right', 'justify']
  }
};

var Wysiwyg =
/** @class */
function (_super) {
  __extends(Wysiwyg, _super);

  function Wysiwyg() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Wysiwyg.prototype.render = function () {
    var _a = this.props,
        value = _a.value,
        onChange = _a.onChange,
        editorProps = __rest(_a, ["value", "onChange"]);

    return React.createElement(Editor, _assign({}, editorProps, {
      editorState: this.props.editorState,
      onEditorStateChange: this.onChange,
      editorClassName: styles$8.editor,
      toolbarClassName: styles$8.toolbar,
      toolbar: toolbarConfig,
      stripPastedStyles: true
    }));
  };

  Wysiwyg.prototype.onChange = function (state) {
    this.props.setFieldValue(this.props.name, state);
  };

  __decorate([boundMethod], Wysiwyg.prototype, "onChange", null);

  return Wysiwyg;
}(Component);

var InputGroupAddon = function InputGroupAddon(props) {
  return React.createElement("span", {
    className: 'input-group-addon px-1 bg-dark-gray'
  }, props.children);
};

var Chartjs;

if (typeof window !== 'undefined') {
  import('chart.js').then(function (chartjs) {
    return Chartjs = chartjs;
  });
}

var ChartjsChart =
/** @class */
function (_super) {
  __extends(ChartjsChart, _super);

  function ChartjsChart(props) {
    var _this = _super.call(this, props) || this;

    _this._ref = React.createRef();
    return _this;
  }

  ChartjsChart.prototype.componentDidMount = function () {
    return __awaiter(this, void 0, void 0, function () {
      var chartCtx;
      return __generator(this, function (_a) {
        if (Chartjs !== undefined && !this._chart) {
          chartCtx = this._ref.current.getContext('2d');
          this._chart = new Chartjs.Chart(chartCtx, this.props.chartOptions);

          if (this.props.renderLegend !== undefined && this._chart) {
            this.props.renderLegend(this._chart.generateLegend());
          }
        }

        return [2
        /*return*/
        ];
      });
    });
  };

  ChartjsChart.prototype.componentWillUnmount = function () {
    if (this._chart) {
      this._chart.destroy();
    }
  };

  ChartjsChart.prototype.render = function () {
    return React.createElement("canvas", {
      ref: this._ref,
      height: this.props.height,
      width: this.props.width,
      className: this.props.className
    });
  };

  return ChartjsChart;
}(PureComponent);

var ErrorPageLayout =
/** @class */
function (_super) {
  __extends(ErrorPageLayout, _super);

  function ErrorPageLayout() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ErrorPageLayout.prototype.render = function () {
    var background = this.props.background;
    return React.createElement("div", {
      className: classNames('middle-box text-center animated fadeIn', background && background + "-bg")
    }, this.props.children);
  };

  return ErrorPageLayout;
}(Component);

var Footer =
/** @class */
function (_super) {
  __extends(Footer, _super);

  function Footer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Footer.prototype.render = function () {
    return React.createElement("div", {
      className: 'footer'
    }, React.createElement("div", {
      className: 'pull-right'
    }, "10GB of ", React.createElement("strong", null, "250GB"), " Free."), React.createElement("div", null, React.createElement("strong", null, "Copyright"), " Example Company \xA9 2015-2016"));
  };

  return Footer;
}(React.Component);

var PageLayout =
/** @class */
function (_super) {
  __extends(PageLayout, _super);

  function PageLayout() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PageLayout.prototype.render = function () {
    return React.createElement("div", {
      className: 'top-navigation'
    }, React.createElement("div", {
      id: 'wrapper'
    }, React.createElement("div", {
      id: 'page-wrapper',
      className: 'gray-bg'
    }, this.props.children)));
  };

  return PageLayout;
}(Component);

var SidebarLayout =
/** @class */
function (_super) {
  __extends(SidebarLayout, _super);

  function SidebarLayout() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SidebarLayout.prototype.render = function () {
    var background = this.props.background;
    return React.createElement("div", {
      id: 'wrapper'
    }, this.props.navigation, React.createElement("div", {
      id: 'page-wrapper',
      className: classNames(background + "-bg", this.props.isFixed && 'fixed')
    }, this.props.children));
  };

  SidebarLayout.defaultProps = {
    background: 'gray'
  };
  return SidebarLayout;
}(Component);

var SidebarLayoutFixedContent = function SidebarLayoutFixedContent(props) {
  return React.createElement("div", {
    className: classNames('wrapper wrapper-content', props.breadcrumbs !== undefined && 'wrapper-content--high', props.className)
  }, React.createElement("div", {
    className: classNames('page-heading-fixed border-bottom white-bg', props.breadcrumbs !== undefined && 'page-heading-fixed--high')
  }, React.createElement("div", {
    className: 'row h-100 justify-content-between align-items-center'
  }, React.createElement("div", {
    className: 'col-auto'
  }, React.createElement("h2", {
    className: classNames('font-bold text-dark mt-0', !props.breadcrumbs && 'mb-0')
  }, props.title), props.breadcrumbs), React.createElement("div", {
    className: 'col-auto'
  }, props.actions))), props.children);
};

var MainNavItemSubmenu =
/** @class */
function (_super) {
  __extends(MainNavItemSubmenu, _super);

  function MainNavItemSubmenu() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MainNavItemSubmenu.prototype.render = function () {
    var isExpanded = this.props.isExpanded;
    return React.createElement("ul", {
      className: "nav nav-second-level collapse " + (isExpanded ? 'in' : '')
    }, this.props.children);
  };

  return MainNavItemSubmenu;
}(Component);

var MainNavItem =
/** @class */
function (_super) {
  __extends(MainNavItem, _super);

  function MainNavItem() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isExpanded: false
    };
    return _this;
  }

  MainNavItem.prototype.render = function () {
    var isExpanded = this.state.isExpanded || this.isActive();
    return React.createElement("li", {
      className: isExpanded ? 'active' : '',
      onClick: this.onClick
    }, this.props.link, this.isExpandable ? React.createElement(MainNavItemSubmenu, {
      isExpanded: isExpanded
    }, this.props.children) : null);
  };
  /**
   * Checks whether this item should be marked as active or not, depending on the current `location.pathname`.
   * Item is marked as active when its path matches but also when its child's path does.
   */


  MainNavItem.prototype.isActive = function () {
    var _this = this;

    var isActive = false;

    if (this.props.path) {
      return this.props.isActiveTester(this.props.path, !!this.props.matchExactPath);
    } // check children


    React.Children.forEach(this.props.children, function (child) {
      if (!child || !child.props.path) {
        return;
      }

      isActive = isActive || _this.props.isActiveTester(child.props.path, !!_this.props.matchExactPath);
    });
    return isActive;
  };
  /**
   * Toggles `isExpanded` state on click but only when this item is not active.
   */


  MainNavItem.prototype.onClick = function () {
    if (this.isExpandable && !this.isActive()) {
      this.setState({
        isExpanded: !this.state.isExpanded
      });
    }
  };

  Object.defineProperty(MainNavItem.prototype, "isExpandable", {
    /**
     * Does this item expand - does it have children items.
     */
    get: function get() {
      return !!this.props.children;
    },
    enumerable: true,
    configurable: true
  });

  __decorate([boundMethod], MainNavItem.prototype, "onClick", null);

  return MainNavItem;
}(Component);

var MainNavItemLabel = function MainNavItemLabel(props) {
  return React.createElement(React.Fragment, null, props.icon ? React.createElement("i", {
    className: "fa fa-" + props.icon
  }) : '', React.createElement("span", {
    className: 'nav-label'
  }, props.title));
};

var NavHeader =
/** @class */
function (_super) {
  __extends(NavHeader, _super);

  function NavHeader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  NavHeader.prototype.render = function () {
    return React.createElement("li", {
      className: 'nav-header'
    }, this.props.children);
  };

  return NavHeader;
}(Component);

var Navigation =
/** @class */
function (_super) {
  __extends(Navigation, _super);

  function Navigation() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Navigation.prototype.render = function () {
    return React.createElement("nav", {
      className: classNames('navbar-default navbar-static-side', this.props.className),
      role: 'navigation'
    }, React.createElement("div", {
      className: 'sidebar-collapse'
    }, React.createElement("ul", {
      className: 'nav metismenu',
      id: 'side-menu'
    }, this.props.children)));
  };

  return Navigation;
}(Component);

var css$9 = ".Dropdown-module_container__2-4u3{position:relative}.Dropdown-module_container__2-4u3 .nw{top:unset;bottom:100%;left:0;right:unset}.Dropdown-module_container__2-4u3 .n{top:unset;bottom:100%;left:50%;right:unset;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.Dropdown-module_container__2-4u3 .ne{top:unset;bottom:100%;left:unset;right:0}.Dropdown-module_container__2-4u3 .sw{top:100%;bottom:unset;left:0;right:unset}.Dropdown-module_container__2-4u3 .s{top:100%;bottom:unset;left:50%;right:unset;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.Dropdown-module_container__2-4u3 .se{top:100%;bottom:unset;left:unset;right:0}.Dropdown-module_item__1BzAu,.Dropdown-module_menu__v_TR3{padding:8px}.Dropdown-module_item__1BzAu:hover{background-color:#f3f6fb}.Dropdown-module_itemText__1G3Sl{font-size:13px;line-height:20px;margin-left:8px}.Dropdown-module_header__3iZiI{text-align:left;padding-left:8px;font-size:13px;line-height:20px;font-weight:600;color:#2e4050}";
var styles$9 = {
  "container": "Dropdown-module_container__2-4u3",
  "menu": "Dropdown-module_menu__v_TR3",
  "item": "Dropdown-module_item__1BzAu",
  "itemText": "Dropdown-module_itemText__1G3Sl",
  "header": "Dropdown-module_header__3iZiI"
};
styleInject(css$9);

var Dropdown =
/** @class */
function (_super) {
  __extends(Dropdown, _super);

  function Dropdown() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.ref = React.createRef();
    _this.state = {
      isOpen: false
    };

    _this.onTriggerClick = function () {
      if (_this.props.isDisabled) {
        return;
      }

      _this.setState(function (state) {
        return {
          isOpen: !state.isOpen
        };
      });
    };

    return _this;
  }

  Dropdown.prototype.componentDidMount = function () {
    document.addEventListener('mousedown', this.onClickDocument);

    if (this.ref.current) {
      this.ref.current.addEventListener('click', this.onTriggerClick);
    }
  };

  Dropdown.prototype.componentWillUnmount = function () {
    document.removeEventListener('mousedown', this.onClickDocument);
  };

  Dropdown.prototype.render = function () {
    return React.createElement("div", {
      ref: this.ref,
      className: classNames(styles$9.container)
    }, this.props.trigger, React.createElement("div", {
      className: classNames(styles$9.menu, this.props.align, 'dropdown-menu', this.state.isOpen && 'show', this.props.className)
    }, this.props.children));
  };

  Dropdown.prototype.onClickDocument = function (e) {
    if (!this.ref.current) {
      return;
    }

    if (this.state.isOpen && !this.ref.current.contains(e.target)) {
      this.setState({
        isOpen: false
      });
    }
  };

  __decorate([boundMethod], Dropdown.prototype, "onClickDocument", null);

  return Dropdown;
}(Component);

var DropdownHeader = function DropdownHeader(props) {
  return React.createElement("h6", {
    className: classNames('dropdown-header', styles$9.header, props.className)
  }, props.children);
};

var DropdownItem = function DropdownItem(props) {
  var t = useTranslation().t;

  var icon = props.icon,
      label = props.label,
      btnProps = __rest(props, ["icon", "label"]);

  return React.createElement("button", _assign({}, btnProps, {
    className: classNames(props.className, 'btn dropdown-item', styles$9.item)
  }), icon && icon, React.createElement("span", {
    className: styles$9.itemText
  }, t(label)));
};

var css$a = ".Modal-module_overlay__19Gko{background-color:rgba(0,0,0,.5);position:fixed;top:0;left:0;width:100%;height:100%;display:-webkit-box;display:flex;-webkit-box-align:start;align-items:flex-start;-webkit-box-pack:center;justify-content:center;padding-top:10%}.Modal-module_modal__2WJ2I,.Modal-module_overlay__19Gko{-webkit-animation-duration:.5s;animation-duration:.5s}";
var styles$a = {
  "overlay": "Modal-module_overlay__19Gko",
  "modal": "Modal-module_modal__2WJ2I"
};
styleInject(css$a);

var Modal = function Modal(props) {
  return React.createElement(ReactModal, _assign({}, props, {
    ariaHideApp: false,
    shouldCloseOnOverlayClick: true,
    overlayClassName: classNames('animated fadeIn modal', styles$a.overlay, props.overlayClassName),
    className: classNames('animated slideInDown', styles$a.modal, props.className)
  }), props.children);
};

var css$b = ".ModalIbox-module_title__1CQTe{border-top-left-radius:4px;border-top-right-radius:4px;padding-left:15px;padding-right:15px}.ModalIbox-module_footer__2IFHp{border-bottom-left-radius:4px;border-bottom-right-radius:4px}";
var styles$b = {
  "title": "ModalIbox-module_title__1CQTe",
  "footer": "ModalIbox-module_footer__2IFHp"
};
styleInject(css$b);

var ModalIbox = function ModalIbox(props) {
  return React.createElement(Modal, _assign({}, props, {
    className: classNames('ibox', props.className)
  }), React.createElement("div", {
    className: classNames('ibox-title', styles$b.title)
  }, props.title), React.createElement("div", {
    className: classNames('ibox-content', props.contentClassName)
  }, props.children), React.createElement("div", {
    className: 'ibox-footer'
  }, props.footer));
};

var css$c = ".ModalConfirm-module_buttonsContainer__2V0Ip{min-width:260px}";
var styles$c = {
  "buttonsContainer": "ModalConfirm-module_buttonsContainer__2V0Ip"
};
styleInject(css$c);
var DEFAULT_LABEL_NO = 'No';
var DEFAULT_LABEL_YES = 'Yes';

var ModalConfirm =
/** @class */
function (_super) {
  __extends(ModalConfirm, _super);

  function ModalConfirm() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ModalConfirm.prototype.render = function () {
    var _a = this.props,
        onYes = _a.onYes,
        onNo = _a.onNo,
        yesLabel = _a.yesLabel,
        noLabel = _a.noLabel,
        noAdditionalProps = _a.noAdditionalProps,
        yesAdditionalProps = _a.yesAdditionalProps,
        modalProps = __rest(_a, ["onYes", "onNo", "yesLabel", "noLabel", "noAdditionalProps", "yesAdditionalProps"]);

    return React.createElement(ModalIbox, _assign({}, modalProps, {
      footer: React.createElement("div", {
        className: classNames('d-flex justify-content-between', styles$c.buttonsContainer)
      }, React.createElement("button", _assign({
        onClick: onNo
      }, noAdditionalProps, {
        className: classNames('btn btn-default btn-w-m', noAdditionalProps && noAdditionalProps.className)
      }), noLabel || DEFAULT_LABEL_NO), React.createElement("button", _assign({
        onClick: onYes
      }, yesAdditionalProps, {
        className: classNames('btn btn-primary btn-w-m', yesAdditionalProps && yesAdditionalProps.className)
      }), yesLabel || DEFAULT_LABEL_YES))
    }), this.props.children);
  };

  ModalConfirm.defaultProps = {
    noAdditionalProps: {},
    yesAdditionalProps: {}
  };
  return ModalConfirm;
}(Component);

var InModal =
/** @class */
function (_super) {
  __extends(InModal, _super);

  function InModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.ref = React.createRef();

    _this.onClickDocument = function (e) {
      if (!_this.ref.current) {
        return;
      }

      if (_this.props.onClose && !_this.ref.current.contains(e.target)) {
        _this.props.onClose();
      }
    };

    return _this;
  }

  InModal.prototype.componentDidMount = function () {
    if (this.props.onClose) {
      document.addEventListener('mousedown', this.onClickDocument);
    }
  };

  InModal.prototype.componentWillUnmount = function () {
    if (this.props.onClose) {
      document.removeEventListener('mousedown', this.onClickDocument);
    }
  };

  InModal.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      if (this.props.isOpen) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }
    }
  };

  InModal.prototype.render = function () {
    if (!this.props.isOpen) {
      return null;
    }

    return ReactDOM.createPortal(React.createElement(React.Fragment, null, React.createElement("div", {
      className: classNames('modal-backdrop fade show', this.props.backdropClassNames)
    }), React.createElement("div", {
      className: classNames('modal inmodal show'),
      tabIndex: -1,
      role: 'dialog',
      "aria-modal": 'true'
    }, React.createElement("div", {
      className: classNames('modal-dialog', this.props.size === 'large' && 'modal-lg')
    }, React.createElement("div", {
      ref: this.ref,
      className: classNames('modal-content', this.props.className)
    }, this.props.children)))), document.body);
  };

  return InModal;
}(Component);

var InModalHeader = function InModalHeader(props) {
  return React.createElement("div", {
    className: classNames('modal-header', props.className)
  }, props.onClose && React.createElement("button", {
    type: 'button',
    className: 'close',
    onClick: props.onClose
  }, React.createElement("span", {
    "aria-hidden": 'true'
  }, "\xD7"), React.createElement("span", {
    className: 'sr-only'
  }, props.closeTitle || 'Close')), props.titleText && React.createElement("h4", {
    className: 'modal-title'
  }, props.titleText), props.titleElement && props.titleElement, props.children);
};

var InModalBody = function InModalBody(props) {
  return React.createElement("div", {
    className: classNames('modal-body', props.noscroll && 'no-scroll', props.className)
  }, props.children);
};

var InModalFooter = function InModalFooter(props) {
  return React.createElement("div", {
    className: classNames('modal-footer', props.className)
  }, props.children);
};

function TabsContent(_a) {
  var children = _a.children,
      isActive = _a.isActive;
  return React.createElement("div", {
    className: classNames('tab-pane', isActive && 'active')
  }, React.createElement("div", {
    className: "panel-body p-5 "
  }, children));
}

var TabsButton =
/** @class */
function (_super) {
  __extends(TabsButton, _super);

  function TabsButton() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  TabsButton.prototype.render = function () {
    var _a = this.props,
        t = _a.t,
        label = _a.label,
        target = _a.target,
        isActive = _a.isActive;
    return React.createElement("li", null, React.createElement("a", {
      className: classNames('nav-link', {
        active: isActive
      }),
      href: "#" + target,
      onClick: this.onClick
    }, t(label)));
  };

  TabsButton.prototype.onClick = function () {
    this.props.onClick(this.props.target);
  };

  __decorate([boundMethod], TabsButton.prototype, "onClick", null);

  return TabsButton;
}(React.PureComponent);

var TabsButton$1 = withTranslation()(TabsButton);

var TabsWrapper =
/** @class */
function (_super) {
  __extends(TabsWrapper, _super);

  function TabsWrapper() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      activeTab: _this.props.defaultTarget
    };

    _this.getCurrentTargetFromLocation = function () {
      if (window) {
        return window.location.hash.replace('#', '');
      }

      return '';
    };

    return _this;
  }

  TabsWrapper.prototype.componentDidMount = function () {
    var targetInHash = this.getCurrentTargetFromLocation();

    if (targetInHash) {
      this.setState({
        activeTab: targetInHash
      });
    }
  };

  TabsWrapper.prototype.onControlClick = function (target) {
    this.setState({
      activeTab: target
    });
  };

  TabsWrapper.prototype.render = function () {
    var panes = this.props.panes;
    return React.createElement("div", {
      className: 'full-width'
    }, React.createElement("div", {
      className: 'row'
    }, React.createElement("div", {
      className: 'col-lg-12'
    }, React.createElement("div", {
      className: 'tabs-container'
    }, React.createElement("ul", {
      className: 'nav nav-tabs',
      role: 'tablist'
    }, panes.map(this.renderPaneTabButton)), React.createElement("div", {
      className: 'tab-content'
    }, panes.map(this.renderPaneTabContent))))));
  };

  TabsWrapper.prototype.isPaneActive = function (_a) {
    var target = _a.target;

    if (this.state.activeTab === target) {
      return true;
    }

    return false;
  };

  TabsWrapper.prototype.renderPaneTabButton = function (pane) {
    return React.createElement(TabsButton$1, {
      target: pane.target,
      label: pane.label,
      isActive: this.isPaneActive(pane),
      onClick: this.onControlClick,
      key: pane.target
    });
  };

  TabsWrapper.prototype.renderPaneTabContent = function (pane) {
    return React.createElement(TabsContent, {
      isActive: this.isPaneActive(pane),
      key: pane.target
    }, pane.content);
  };

  __decorate([boundMethod], TabsWrapper.prototype, "onControlClick", null);

  __decorate([boundMethod], TabsWrapper.prototype, "renderPaneTabButton", null);

  __decorate([boundMethod], TabsWrapper.prototype, "renderPaneTabContent", null);

  return TabsWrapper;
}(Component);

export { ChartjsChart, Checkbox, CheckboxGroup, DatePickerInput, Dropdown, DropdownHeader, DropdownItem, ErrorContext, ErrorPageLayout, FieldWithHelp$1 as FieldWithHelp, FileUpload, Footer, GeoLocation, Hr, InModal, InModalBody, InModalFooter, InModalHeader, InputGroupAddon, InputWheel, Label, LabelFieldHorizontal$1 as LabelFieldHorizontal, LabelType, LoginForm, MainNavItem, MainNavItemLabel, MainNavItemSubmenu, Modal, ModalConfirm, ModalIbox, NavHeader, Navigation, NumberInput, PageLayout, PdfViewer, Preloader, PropertyRow, Radio, Select, SidebarLayout, SidebarLayoutFixedContent, SpinnerCircle, SpinnerThreeBounce, Switch, TabsButton$1 as TabsButton, TabsContent, TabsWrapper, TextInput, WheeledNumberInput, Wysiwyg, formValueToString, numberToString, stringToNumber, withErrorsContext };